import axios from "axios";
import { useEffect, useMemo, useState } from "react";
import Breadcrumbs from "../../components/Common/Breadcrumbs/AntdBreadcrumbs";
import CommonFilterModal from "../../components/Common/CommonFilterModal";
import FilterOptions from "../../components/Common/CommonFilterOptions";
import Pagination from "../../components/Common/CommonPagination";
import ExcelDownload from "../../components/Utils/excelDownload";
import MainconternLayout from "../../components/Layout/MainconternLayout";
import NavBarTitles from "../../components/Common/TabBar";
import AssignedTo from "../../components/Modal/AssignedTo";
import Deletepopup from "../../components/Modal/Deletepopup";
import LeadStatus from "../../components/Modal/LeadStatus";
import LeadStatusConfirm from "../../components/Modal/LeadStatusConfirm";
import SucessModal from "../../components/Modal/SucessModal";
import useDebouncedSearch from "../../components/Utils/hooks/useDebouncedSearch";
import usePageChange from "../../components/Utils/hooks/usePageChange";
import usePaginatedData from "../../components/Utils/hooks/usePaginatedData";
import useSortHandler from "../../components/Utils/hooks/useSortHandler";
import ExcelDownloadModal from "../../Pages/Masters/Common/excelDownloadAccess";
import {
  HealthSynergynavBarData,
  OtherRegistrationTable,
  Others,
  OtherscolumnOrder,
} from "./HealthSynergyConst";
import useDeleteHandler from "../../components/Utils/hooks/useDeleteHandler";

const emptyFilterValues = {
  Type: [],
};

const OtherRegistration = () => {
  const [filtered_records, setFilteredRecords] = useState([]);
  const limit = 10;
  const [sort, setSort] = useState("newest");
  const [sortName, setSortName] = useState("Sort by");

  const typedata = [];
  const [types, setTypes] = useState([]);

  const [assignModal, setAssignModal] = useState({ id: "", status: false });
  const [leadStatusModal, setLeadStatusModal] = useState({
    id: "",
    status: false,
  });
  const [success, setSuccess] = useState(false);
  const [leadStatussuccess, setLeadStatusSuccess] = useState(false);
  const [leadStatusConfirmModal, setLeadStatusConfirmModal] = useState({
    leadType: "",
    status: false,
    id: "",
  });
  const [del, setDel] = useState(false);
  const [id, setId] = useState("");
  const [search, setSearch] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isFilterModalVisible, setIsFilterModalVisible] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("Type");
  const [selectedValues, setSelectedValues] = useState(emptyFilterValues);
  const [loader, setLoader] = useState(true);

  useEffect(() => {
    const fetchTypes = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}types/getarray`,
        );
        setTypes(response.data || []);
      } catch (error) {
        console.error("Error fetching types:", error);
        setTypes([]);
      }
    };

    fetchTypes();
  }, []);

  const Filters = useMemo(
    () => ({
      Type: types,
    }),
    [types],
  );

  const handleSortClick = useSortHandler(setSort, setSortName);

  const { records, totalCount, pagination, setPagination, fetchData } =
    usePaginatedData({
      apiUrl: `${process.env.REACT_APP_API_URL}other-registration/list`,
      initialParams: {
        sort,
        searchText: search,
        selectedValues,
      },
    });

  useEffect(() => {
    !assignModal.status && !leadStatusModal.status && setLoader(true);
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    pagination.skip,
    pagination.limit,
    sort,
    search,
    success,
    leadStatussuccess,
  ]);

  const onClickDownload = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}other-registration/list`,
        {
          skip: 0,
          limit: 3000,
          searchText: search,
          values: {
            type: typedata,
          },
          sort: sort,
        },
      );
      if (!response?.data?.rows?.length) {
        throw new Error("No records available to download.");
      }
      const records = response.data.rows;
      const formattedRecords = records.map((record, index) => ({
        "S.No": index + 1,
        "Time of Registration": record.createdAt
          ? new Date(record.createdAt).toLocaleTimeString()
          : "",
        "Date of Registration": record.createdAt
          ? new Date(record.createdAt).toLocaleDateString()
          : "",
        Name: record.name || "",
        "Mobile Number": record.mobile || "",
        "Email ID": record.email || "",
        Type: record.type || "",
        "City / Town Location": record.location || "",
        Message: record.message || "",
        "Assigned To": record.assigned_to || "",
        "Lead Status": record.lead_status || "",
        // Actions: "",
      }));

      ExcelDownload(
        formattedRecords,
        OtherscolumnOrder,
        "other-registration.xlsx",
      );
      // console.log("File downloaded successfully.");
    } catch (err) {
      console.error(
        "Error downloading the file while getting all Doctor registration records",
        err,
        "err.message",
        err?.message,
      );
      // console.error("Error downloading the file:", err.message);
      alert(err?.message || "An error occurred while downloading the file.");
    }
  };

  const handleDelete = useDeleteHandler(
    "other-registration",
    fetchData,
    setDel,
  );

  const handleContact = (id) => {
    setLoader(true);
    axios
      .patch(
        `${process.env.REACT_APP_API_URL}other-registration/update/${id}`,
        {
          contact: true,
          notContacted: false,
          onBoard: false,
        },
      )
      .then((result) => {
        fetchData();
      });
  };

  const handleNotContact = (id) => {
    setLoader(true);
    axios
      .patch(
        `${process.env.REACT_APP_API_URL}other-registration/update/${id}`,
        {
          contact: false,
          notContacted: true,
          onBoard: false,
        },
      )
      .then((result) => {
        fetchData();
      });
  };

  const handleOnBoard = (id) => {
    setLoader(true);
    axios
      .patch(
        `${process.env.REACT_APP_API_URL}other-registration/update/${id}`,
        {
          contact: false,
          notContacted: false,
          onBoard: true,
        },
      )
      .then((result) => {
        fetchData();
      });
  };

  const successModalClose = () => {
    setSuccess(false);
    setLeadStatusSuccess(false);
    fetchData();
  };

  const handlePageChange = usePageChange(pagination, setPagination);

  const debouncedSearch = useDebouncedSearch(setSearch, () => {
    setPagination((prev) => ({ ...prev, skip: 0, currentPage: 1 }));
  });

  useEffect(() => {
    records && setTimeout(() => setLoader(false));
  }, [records]);
  return (
    <>
      <MainconternLayout
        header={
          <div className="d-flex pb-2 flex-wrap align-items-center justify-content-between">
            <Breadcrumbs
              className="healthsyMasterBreadCrumbs"
              breadcrumbsList={Others}
            />
          </div>
        }
        footer={
          <div className="mt-4 col d-flex align-items-center pagination justify-content-between admin-pagination">
            <div className="border border-danger bg-bg-light px-2 py-1 rounded">
              Total : {totalCount}
            </div>
            {totalCount > pagination.limit && (
              <Pagination
                skip={pagination.skip}
                limit={limit}
                total={totalCount}
                onPageChange={(selected) => handlePageChange({ selected })}
              />
            )}
          </div>
        }
      >
        <div className="healtharticle-container healthsyContainer">
          <NavBarTitles titles={HealthSynergynavBarData} />
          <FilterOptions
            limit={pagination.limit}
            // sortshow={sortshow}
            sortName={sortName}
            search={search}
            setFilterShow={() => setIsFilterModalVisible(true)}
            // setSortShow={setSortShow}
            onChange={debouncedSearch}
            setLimit={(val) =>
              setPagination((prev) => ({
                ...prev,
                limit: val,
                skip: 0,
                currentPage: 1,
              }))
            }
            downloadExcel={true}
            onClickDownload={() => setIsModalOpen(true)}
            handleSortClick={handleSortClick}
          />
          <OtherRegistrationTable
            filtered_records={filtered_records}
            records={records}
            skip={pagination.skip}
            setAssignModal={setAssignModal}
            setLeadStatusModal={setLeadStatusModal}
            setId={setId}
            setDel={setDel}
            handleContact={handleContact}
            handleNotContact={handleNotContact}
            handleOnBoard={handleOnBoard}
            loader={loader}
          />
        </div>
      </MainconternLayout>
      {del === true && (
        <Deletepopup
          handleDelete={handleDelete}
          id={id}
          handleClose={() => setDel(false)}
        />
      )}
      {/*---------Filter Portion--------*/}

      <CommonFilterModal
        visible={isFilterModalVisible}
        onClose={() => {
          setIsFilterModalVisible(false);
          setSelectedCategory(Object.keys(Filters)[0]); // Reset to first category
        }}
        onApply={() => {
          setIsFilterModalVisible(false);
          setSelectedCategory(Object.keys(Filters)[0]); // Reset to first category
          setPagination((prev) => ({ ...prev, skip: 0, currentPage: 1 }));
          fetchData(); // trigger fresh data with selected filters
        }}
        onReset={() => {
          setSelectedValues({
            Type: [],
          });
          setFilteredRecords([]);
          setPagination((prev) => ({ ...prev, skip: 0, currentPage: 1 }));
          setSelectedCategory(Object.keys(Filters)[0]); // Reset on reset too (optional)
        }}
        filters={Filters}
        selectedCategory={selectedCategory}
        setSelectedCategory={setSelectedCategory}
        selectedValues={selectedValues}
        setSelectedValues={setSelectedValues}
        // handleSortClick={handleSortClick} // Add this line
      />

      {assignModal.status === true && (
        <AssignedTo
          id={assignModal?.id}
          setAssignModal={setAssignModal}
          setSuccess={setSuccess}
          pathName="other-registration"
        />
      )}

      {success && (
        <SucessModal
          name="BD"
          post="Assigned"
          onClick={() => successModalClose()}
          page="/other-registration"
        />
      )}

      {leadStatusModal.status === true && (
        <LeadStatus
          id={leadStatusModal?.id}
          setLeadStatusModal={setLeadStatusModal}
          setLeadStatusSuccess={setLeadStatusSuccess}
          setLeadStatusConfirmModal={setLeadStatusConfirmModal}
        />
      )}

      {leadStatusConfirmModal.status === true && (
        <LeadStatusConfirm
          id={leadStatusConfirmModal?.leadType}
          setLeadStatusConfirmModal={setLeadStatusConfirmModal}
          setLeadStatusSuccess={setLeadStatusSuccess}
          leadStatusConfirmModal={leadStatusConfirmModal}
          formType="other-registration"
        />
      )}

      {leadStatussuccess && (
        <SucessModal
          name="Lead Status"
          pa
          post="Updated"
          page="/other-registration"
          onClick={() => successModalClose()}
        />
      )}
      <ExcelDownloadModal
        onClickDownload={onClickDownload}
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
      />
    </>
  );
};

export default OtherRegistration;
